import React from 'react';

import { withRouter } from 'next/router';

import Icon from '../../../components/basic/Icon';
import { getString } from '../../../helpers/string-helpers';
import Link from '../LinkHelper';
import TopBar from '../TopBar';

class BlogHeader extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      activeCountry: null,
      activeIndex: null,
      activeLang: null,
      dropdownIsDisabled: false,
      isDesktop: false,
      isFocused: false,
      isHidden: false,
      isLanguageToggled: false,
      isOpened: false,
      isSearchOpen: false,
      maxNavItems: 4,
      navItemsSpacing: 28,
      scrolled: false,
      search: this.props.search,
    };

    this.open = this.open.bind(this);
    this.openSearch = this.openSearch.bind(this);
    this.onScroll = this.onScroll.bind(this);
    this.closeMobileNav = this.closeMobileNav.bind(this);
    this.onChange = this.onChange.bind(this);
    this.strings = this.props.menu?.strings || {};
    this.theme = this.props.theme;

    this.popularSearches = getString('popularSearchesListText', this.props.locale);

    this.navSocialItems = [
      {
        href: 'https://twitter.com/rippling',
        imgSrc:
          'https://rippling.imgix.net/images/blog-signup-social-icon-twitter.svg',
        name: 'Twitter',
      },
      {
        href: 'https://www.facebook.com/ripplingapp/',
        imgSrc:
          'https://rippling.imgix.net/images/blog-signup-social-icon-facebook.svg',
        name: 'Facebook',
      },
      {
        href: 'https://www.linkedin.com/company/rippling/',
        imgSrc:
          'https://rippling.imgix.net/images/ULinMldl-blog-signup-social-icon-linkedIn.svg',
        name: 'LinkedIn',
      },
      {
        href: 'https://www.instagram.com/ripplinghq/',
        imgSrc:
          'https://rippling.imgix.net/images/7zzsKYkk-blog-signup-social-icon-instagram.svg',
        name: 'Instagram',
      },
      {
        href: 'https://www.youtube.com/@ripplinghq',
        imgSrc:
          'https://rippling.imgix.net/images/Oa5Ko61K-blog-signup-social-icon-youtube.svg',
        name: 'Youtube',
      },
    ];
  }

  componentDidMount() {
    window.addEventListener('scroll', this.onScroll);
    this.pathname = this.props.router.asPath;
  }

  componentDidUpdate(prevProps) {
    this.theme = prevProps.theme;
    if (this.pathname !== this.props.router.asPath) {
      this.pathname = this.props.router.asPath;

      this.setState({
        activeIndex: 0,
        isOpened: false,
      });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.onScroll);
  }

  left() {
    const logo = () => {
      let homeLink = '/';

      if (this.props.locale === 'nl-NL' || this.props.locale === 'de-DE') {
        homeLink = `${this.props.locale}/global`;
      }

      return (
        <>
          <Link
            anchorProps={{ title: 'Rippling' }}
            className="header__logo block leading-0"
            href={homeLink}
            locale={this.props.locale}
          >
            <svg
              fill="none"
              height="40"
              viewBox="0 0 40 40"
              width="40"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                fill="#FDB71C"
                height="40"
                rx="20"
                width="40"
              />
              <path
                d="M16.3563 17.0308C16.3563 15.5402 15.6755 14.2074 14.553 13.332H11.3828C12.7444 14.3468 13.4772 15.5639 13.4772 17.0308C13.4772 18.4976 12.7444 19.7069 11.3828 20.7295C12.6145 21.2842 13.3031 22.3094 13.3031 23.7605V26.6654H16.1822V23.7605C16.1822 22.2332 15.595 21.1659 14.5634 20.7295C15.6781 19.8541 16.3589 18.5213 16.3589 17.0308H16.3563Z"
                fill="#292929"
              />
              <path
                d="M28.8187 17.0308C28.8187 15.5402 28.1379 14.2074 27.0232 13.332H23.8504C25.212 14.3468 25.9448 15.5639 25.9448 17.0308H25.937C25.937 18.4976 25.2042 19.7069 23.8426 20.7295C25.0743 21.2842 25.7629 22.3094 25.7629 23.7605V26.6654H28.642V23.7605C28.642 22.2332 28.0548 21.1659 27.0232 20.7295C28.1379 19.8541 28.8187 18.5213 28.8187 17.0308Z"
                fill="#292929"
              />
              <path
                d="M22.5927 17.0308C22.5927 15.5402 21.9119 14.2074 20.7972 13.332H17.6244C18.986 14.3468 19.7188 15.5639 19.7188 17.0308H19.711C19.711 18.4976 18.9782 19.7069 17.6166 20.7295C18.8483 21.2842 19.5369 22.3094 19.5369 23.7605V26.6654H22.416V23.7605C22.416 22.2332 21.8288 21.1659 20.7972 20.7295C21.9119 19.8541 22.5927 18.5213 22.5927 17.0308Z"
                fill="#292929"
              />
            </svg>
          </Link>
          <Link
            anchorProps={{ title: 'Rippling Blog' }}
            className="header__logo ml-10 font-medium text-20 leading-24 tracking-[-0.02em] text-darkplum no-underline"
            href="/blog"
            locale={this.props.locale}
          >
            Blog
          </Link>
        </>
      );
    };

    return (
      <div className="header__left md:min-w-400">
        {logo()}
        <div className="header__blogStatement font-body text-16 font-semibold pl-16 border-solid border-l-1 border-[#DDDBD6] ml-16 flex items-center pt-[3px] xsx:hidden">
          <Link
            anchorProps={{ title: `Rippling Blog : ${getString('titleText', this.props.locale)}` }}
            className="text-darkplum no-underline"
            href="/blog"
            locale={this.props.locale}
          >
            {getString('titleText', this.props.locale)}
          </Link>
        </div>
      </div>
    );
  }

  right({ locale }) {
    const nav = () => {
      const { isHidden } = this.state;

      const menuList = (topics) => {
        return (
          <ul
            className="blogNavigation__list items-center"
            id="blogNavigation__list"
          >
            <div style={{ margin: '0 -28px' }}>
              {topics.map((item, i) => {
                const {
                  href, name, slug,
                } = item;
                const hiddenNavItem =
                  slug === 'company' ||
                  slug === 'product' ||
                  slug === 'business-building' ||
                  slug === 'for-partners' ||
                  slug === 'founders' ||
                  slug === null
                    ? 'hidden'
                    : '';

                return (
                  <li
                    key={i}
                    className={`blogNavigation__item text-15 font-normal leading-22 tracking-20 item ${hiddenNavItem}`}
                    id={`blogNavigation__item-${i}`}
                  >
                    <a
                      className={`blogNavigation__anchor${
                        this.props.current === slug ? ' -is-active' : ''
                      } no-underline`}
                      data-slug={slug}
                      href={href}
                      onClick={(e) => this.navigationRouter(e)}
                      title={name}
                    >
                      {name}
                    </a>
                  </li>
                );
              })}
            </div>
          </ul>
        );
      };

      return (

        // TO DO: make sure blog nav works with topbar (toolbarNotificationActive)
        <div
          className={`blogNavigation${
            isHidden ? ' blogNavigation--hidden' : ''
          }`}
        >
          <div className="blogNavigation__container">
            {/* Desktop navigation */}
            {menuList(this.props.topics)}
            <div
              className={`blogNavigation__more pl-28 text-15 font-normal leading-22 tracking-20 blogNavigation__anchor${
                this.props.current === 'more' ? ' -is-active' : ''
              }`}
              onClick={this.open}
              role="button"
            >
              {getString('moreText', locale)}
            </div>
            <div
              className="blogNavigation__search pt-4 pb-4"
              onClick={this.openSearch}
            >
              <div
                className="w-40 h-40 flex items-center justify-center bg-secondary-dark-eggshell rounded-2"
              >
                <div className="w-24 h-24 cursor-pointer flex items-center justify-center">
                  <Icon
                    attributes={{
                      className: 'w-14 h-14 search-icon',
                      color: 'black',
                      name: 'Search',
                      style: 'stroked',
                      type: 'functional',
                    }}
                  />
                  <Icon
                    attributes={{
                      className: 'w-15 h-15 close-icon hidden',
                      color: 'white',
                      name: 'XThin',
                      style: 'filled',
                      type: 'functional',
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    };

    return (
      <div
        className="header__right justify-end items-center flex flex-row top-0 left-0 h-100% pb-0 bg-transparent"
      >
        {nav()}

        <div className="flex justify-end ml-8 mr-28 md:mr-0">
          {/* <LanguageSelector languages={menu.languages} router={router} strings={menu.strings} /> */}
          {this.buttons()}
        </div>
      </div>
    );
  }

  buttons(noHamburger) {
    const { options } = this.props;

    const ctaText = ['/on-demand-demo', '/interactive-tour'].includes(this.pathname)
      ? this.strings.liveDemo
      : this.strings.seeRippling;

    // @TODO: Provide link options in Wordpress
    const link = '/request-demo';
    const demoButton = <Link href={link}>{ctaText}</Link>;
    const loginButton = (
      <a
        className=""
        href="https://app.rippling.com/login"
        id="header-login-btn"
        onClick={(evt) => {
          // we want to prevent it from navigating before we log the event,
          // and we need to keep the href for crawlers...
          evt.preventDefault();
          window.location.href = 'https://app.rippling.com/login';
        }}
      >
        {this.strings.login}
      </a>
    );
    const hasLogin = options.button && options.button.includes('login');
    const hasCta = options.button && options.button.includes('demo');

    return (
      <div
        className={`header__buttons${noHamburger ? ' -no-hamburger' : ''}${
          hasLogin ? '' : ' -only-button'
        }`}
      >
        {hasLogin && (
          <div
            className={`${
              hasCta
                ? ' -md:mb-16 order-2 md:order-1 login-button md:is-style-p2 md:font-medium md:text-accent-yellow md:pr-24 md:pl-24 md:h-40 md:flex md:items-center md:cursor-pointer md:border-l-1 md:border-white md:border-opacity-15'
                : 'btn is-style-primary -only-button'
            }`}
          >
            {loginButton}
          </div>
        )}

        {hasCta && (
          <div
            className={`btn is-style-${
              hasLogin ? 'primary' : 'secondary'
            } order-1 md:order-2`}
          >
            {demoButton}
          </div>
        )}
      </div>
    );
  }

  navigationRouter(e) {
    e.preventDefault();

    const slug = e?.target?.attributes['data-slug']?.value;
    const status = true;
    const name = e?.target?.attributes.title?.value;

    if (this.props.router.route === '/blog/topics') {
      this.props.adjustTopics(name, slug, status, true);
      if (name === 'All') {
        this.props.router.replace('/blog/topics', '', { shallow: true });
      } else {
        this.props.router.replace(`/blog/topics?topics=${slug}`, '', { shallow: true });
      }
    } else {
      this.props.router.push(`/blog/topics?topics=${slug}`);
    }
  }

  searchRouter(e) {
    e.preventDefault();

    if (this.props.router.route === '/blog/search') {
      const linkValue = e.target.attributes?.title?.value;
      const searchInputValue = e.target.value;
      const searchQueryValue =
        linkValue || searchInputValue || this.state.search;

      this.props.setSearch(searchQueryValue);
      this.props.router.replace(`/blog/search?query=${searchQueryValue}`, '', { shallow: true });
    } else {
      this.props.router.push(`/blog/search/?query=${
        e?.target?.attributes.title?.value || this.state.search
      }`);
    }
  }

  searchModal({ locale }) {
    this.textInput = React.createRef();
    const setSearch = (input) => this.setState({ search: input });

    // because the search shares logic between the header search input and the search page input, if on the search page then props.search will get supplied, otherwise use the props.state. Probably a better way to do this.
    let inputValue = '';
    if (this.props.router.route === '/blog/search') {
      inputValue = this.props.search;
    } else if (this.state.search) {
      inputValue = this.state.search;
    }

    return (
      <div className="header__searchModal overflow-scroll absolute opacity-0 top-0 left-0 w-screen -z-1000 h-0 bg-plum">
        <div className="w-100% bg-plum h-80 md:h-[90px] top-0 left-0 border-solid border-b-1 border-[#663C4E] fixed z-1000" />
        <div className="header__searchModalInner pt-80 hidden">
          <div className="header__searchModalInnerContent max-w-[1057px] mx-auto w-93%">
            <div
              ref={this.textInput}
              className="header__searchModalInput pb-12 border-solid border-b-1 border-[#663C4E]"
            >
              <input
                className="bg-plum w-100% text-42 leading-48 font-semibold"
                onChange={(e) => {
                  if (this.props.router.route === '/blog/search') {
                    this.props.setSearch(e.target.value);
                  } else {
                    setSearch(e.target.value);
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    this.openSearch();
                    this.searchRouter(e);
                  }
                }}
                placeholder={getString('searchQueryPlaceholderText', locale)}
                value={inputValue}
              />
              <div
                className={`header__searchModalInputTextBorder w-fit bg-plum h-0 overflow-hidden text-plum top-[13px] border-solid border-t-1 border-yellow text-26 md:text-42 leading-48 font-semibold pr-2 ${
                  this.state.search ? '' : 'opacity-0'
                }`}
              >
                {inputValue}
              </div>

              <div
                className={`cursor-pointer absolute z-1000 top-50% right-0 -translate-y-50% ${
                  this?.props?.search || this?.state?.search ? '' : 'opacity-0'
                }`}
                onClick={() => {
                  {
                    if (this.props.router.route === '/blog/search') {
                      this.props.setSearch('');
                    } else {
                      setSearch('');
                    }
                    this.textInput.current.querySelector('input').focus();
                  }
                }}
              >
                <div className="pointer-events-none w-22 h-22 rounded-50% cursor-pointer flex items-center justify-center">
                  <Icon
                    attributes={{
                      className: 'w-15 h-15',
                      color: 'white',
                      name: 'XThin',
                      style: 'filled',
                      type: 'functional',
                    }}
                  />
                </div>
              </div>
            </div>

            {this.props.topics ? (
              <div className="header__searchModalTopicsWrapper uppercase pt-60 text-[#BFBEBE] text-11 font-display">
                <p className="is-style-overline">{getString('topicsText', locale)}</p>
                <div className="header__searchModalTopics flex flex-wrap">
                  {this.props.topics.map((item, index) => {
                    if (
                      item?.slug !== 'business-building' &&
                      item?.slug !== 'for-partners'
                    ) {
                      return (
                        <a
                          key={index}
                          className="header__searchModalTopic bg-[#663C4E] py-12 px-18 mr-8 mt-8 text-[#BFBEBE] no-underline hover:text-plum hover:bg-[#e8dae0] tracking-125"
                          data-slug={item.slug}
                          href={item.href}
                          onClick={(e) => {
                            this.navigationRouter(e);
                            this.openSearch();
                          }}
                          title={item.name}
                        >
                          {item.name}
                        </a>
                      );
                    }
                  })}
                </div>
              </div>
            ) : null}

            {this.popularSearches ? (
              <div className="header__searchModalPopularSearchesWrapper pt-60 text-[#BFBEBE] text=11">
                <p className="is-style-overline">
                  {getString('popularSearchesText', locale)}
                </p>
                <div className="header__searchModalPopularSearches flex flex-col">
                  {this.popularSearches.map((item, index) => {
                    return (
                      <a
                        key={index}
                        className="header__searchModalPopularSearch text-white text-30 font-body no-underline text-decoration-none font-semibold capatalize pb-24 multiLine-draw-card"
                        href={item.href}
                        onClick={(e) => {
                          console.log(e);
                          this.searchRouter(e);
                          this.openSearch();
                        }}
                        title={item.name}
                      >
                        <span className="multiLine-draw" title={item.name}>
                          {item.name}
                        </span>
                      </a>
                    );
                  })}
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    );
  }

  mobileModal(props) {
    return (
      <div
        className="header__mobileDim absolute opacity-0 top-0 left-0 w-screen -z-1000"
        onClick={() => {
          this.open();
        }}
      >
        <div className="header__mobilePanel overflow-auto bg-plum h-screen w-[320px] absolute right-[-320px] md:w-[420px] md:right-[-420px]">
          <ul className="header__mobileMenu list-none pl-50 pt-50 md:pl-64">
            {this.props.topics.map((item, i) => {
              const {
                href, name, slug,
              } = item;

              let showItem = true;
              if (props.locale === 'en-US') {
                showItem = slug !== 'business-building' && slug !== 'for-partners';
              } else if (props.locale !== 'en-US') {
                showItem = slug !== 'founders';
              }

              if (showItem) {
                return (
                  <li
                    key={i}
                    className="header__mobileMenuItem font-body text-white text-36 font-semibold leading-48 pb-12 md:text-42 md:pb-16"
                  >
                    <a
                      className={`header__mobileMenuItemLink${
                        this.props.current === slug ? ' -is-active' : ''
                      } no-underline hover:text-accent-yellow`}
                      data-slug={slug}
                      href={href}
                      onClick={(e) => {
                        this.navigationRouter(e);
                        this.open();
                      }}
                      title={name}
                    >
                      {name}
                    </a>
                  </li>
                );
              } else {
                return null;
              }
            })}
          </ul>
          <div className="header__mobileSocial flex max-h-[180px] h-100% items-end">
            <ul className="pl-50 pb-50 md:pl-64 flex list-none">
              {this.navSocialItems.map((item, index) => {
                return (
                  <li key={index} className="mr-13 sm:mr-13 last-of-type: mr-0">
                    <a
                      className="block w-40 h-40 md:w-48 md:h-48"
                      href={item.href}
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      <img
                        alt={item.name}
                        loading="lazy"
                        src={item.imgSrc}
                      />
                    </a>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    );
  }

  onChange(e) {
    const value = e.target.value;

    // TO DO: Make Gatsby routing happen
    this.props.router.push(value);
  }

  mobileSpot() {
    const { isOpened } = this.state;
    const { options } = this.props;

    if (options.nav?.includes(false)) {
      return this.buttons(true);
    } else {
      return (
        <div
          className="hamburger"
          onClick={this.open}
          role="button"
          tabIndex={0}
        >
          <div
            aria-label="Toggle navigation visibility"
            className={`hamburger-icon${isOpened ? ' -active' : ''}`}
          />
        </div>
      );
    }
  }

  onScroll(e) {
    const scrollTop = e.target.scrollingElement.scrollTop;
    const scrolled = scrollTop > 50;

    if (
      scrolled && !this.state.scrolled ||
      !scrolled && this.state.scrolled
    ) {
      this.setState({ scrolled });
    }
  }

  open() {
    this.setState({
      activeIndex: null,
      isOpened: !this.state.isOpened,
    });
  }

  openSearch() {
    this.setState({ isSearchOpen: !this.state.isSearchOpen });
  }

  toggleLanguageTabs() {
    let { isLanguageToggled } = this.state;
    isLanguageToggled = !isLanguageToggled;
    this.setState({ isLanguageToggled: isLanguageToggled });
  }

  closeMobileNav() {
    // TODO Find more graceful way to handle bug when mobile header is scrolled
    const mobileWrapper = document.querySelector('.header__mobileWrapper');
    mobileWrapper.scrollTop = 0;

    this.setState({ isOpened: false });
  }

  render() {
    const {
      isOpened, isSearchOpen, scrolled,
    } = this.state;
    const { options, topbars } = this.props;

    const invertedClass = options.inverted?.includes(false) ? ' -inverted' : '';

    const isSearchOpenClass = isSearchOpen ? ' -search-is-open' : '';
    const isOpenedClass = isOpened ? ' -is-opened' : '';
    const scrolledClass = scrolled ? ' -scroll' : '';

    const modifierClasses = `${invertedClass}${isOpenedClass}${isSearchOpenClass}${scrolledClass}`;

    return options.header?.includes(false) ? null : (
      <div className={`BlogHeader${this?.theme ? ` -${this.theme}` : ''}`}>
        {topbars && <TopBar pageType={this.props.pageType} topbars={topbars} />}
        <header
          ref={(c) => this.header = c}
          className={`header header__topbar${modifierClasses}`}
        >
          <div className="header__mobileWrapper overflow-visible ">
            <div className="header__wrapper max-w-100% mx-auto w-100% xsx:w-93% sm:w-[79%] md:w-93% blog-lg:max-w-[1276px] blog-lg:w-100%">
              {this.left()}

              {this.right(this.props)}

              {this.mobileSpot()}
            </div>

            {this.searchModal(this.props)}

            {this.mobileModal(this.props)}
          </div>
        </header>
      </div>
    );
  }
}

export default withRouter(BlogHeader);
